<div
  class="group pointer-events-auto bottom-0 flex h-full w-full -translate-x-8 flex-row items-center justify-start">
  <button
    class="bg-theme-gray-500 pointer-events-auto hidden h-[26px] w-[26px] items-center justify-center rounded-md group-hover:flex"
    (click)="buttonClicked.emit(); $event.stopPropagation()"
    (mousedown)="$event.preventDefault(); $event.stopPropagation()">
    @if (isIgnored) {
      <span class="material-icons">add</span>
    } @else {
      <span class="material-icons">close</span>
    }
  </button>
</div>
